import {
	animate,
	group,
	query,
	style,
	transition,
	trigger,
} from '@angular/animations';

export const fader = trigger('routeTransition', [
	transition('* <=> *', [
		query(
			':enter, :leave',
			[
				style({
					position: 'absolute',
					inset: '0 0 auto',
					width: '100%',
					minHeight: '100svh',
					padding: '0 0.5rem',
					pointerEvents: 'none',
				}),
			],
			{ optional: true }
		),
		query(':enter', [style({ opacity: 0 })], { optional: true }),
		query(':leave', [style({ opacity: 1 })], { optional: true }),
		group([
			query(':leave', [animate('200ms ease-in-out', style({ opacity: 0 }))], {
				optional: true,
			}),
			query(':enter', [animate('1000ms ease-in-out', style({ opacity: 1 }))], {
				optional: true,
			}),
			query(':leave *', [style({}), animate(1, style({}))], { optional: true }),
		]),
	]),
]);
